import ApiService from './ApiService'
import createCrudService from 'utils/createCrudService'

const crud = createCrudService('company/branches', { useFileUpload: true, extraParams: ['company'] })

export const { getApiData, createApiRecord, getApiRecord, updateApiRecord, updateApiStatus } = crud
export const patchBranch = (id, data) => ApiService.patch(`/company/branches/${id}/`, data)
export const getApiTimezones = () => ApiService.get('/company/timezones/')
export const attachImagesApi = data => ApiService.post('/company/branch-images/', data)
export const deleteBranchImageApi = id => ApiService.delete(`/company/branch-images/${id}/`)
